<template>
  <ejs-dialog
    ref="formDialog"
    id="calendar-form"
    class="dialog-karin"
    target="#dialogCalendars"
    :isModal="true"
    :visible="showing"
    :header="header"
    :width="width"
    :showCloseIcon="true"
    :close="onDialogClose"
    :open="onDialogOpen"
    z-index="1003"
  >
    <div class="col-lg-12 e-input-section">
      <div class="content-wrapper">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
            <div class="card">
              <div class="card-body">
                <!-- Formulario Calendar -->
                <div class="row row-eq-height">
                  <div
                    class="col-xs-12 col-sm-12 col-lg-6 col-md-6"
                    v-show="showId"
                  >
                    <div class="form-group">
                      <label
                        class="e-text"
                        :class="{ 'e-warning': hasError('id') }"
                        >Id</label
                      >
                      <input
                        id="id"
                        class="e-input"
                        v-model="m_data.id"
                        type="text"
                        disabled
                        @blur="validateField('id')"
                      />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6 ">
                    <div class="centered">
                      <ejs-switch
                        cssClass="align-middle"
                        id="isActive"
                        v-model="m_data.isActive"
                        :checked="m_data.isActive"
                        :disabled="isFormReadOnly || !canDelete"
                      >
                      </ejs-switch>
                      <label
                        for="isActive"
                        class="e-text align-middle switch-label"
                        >{{ m_data.isActive ? "Activo" : "Inactivo" }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-xs-12 col-sm-12 col-lg-12 col-md-12"
                    :style="marginTopId"
                  >
                    <label class="e-text">Descripción Calendario</label>
                    <input
                      id="name"
                      class="e-input"
                      :class="{ 'e-warning': hasError('description') }"
                      type="text"
                      required
                      v-model="m_data.description"
                      :readonly="isFormReadOnly"
                      @input="validateField('description')"
                      @blur="validateField('description')"
                      placeholder="Descripción Calendario"
                    />
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('description') }"
                      v-text="m_errors.description"
                    >
                    </span>
                  </div>

                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Domingo"
                      :checked="m_data.sundayEnabled"
                      readonly="true"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Lunes"
                      :checked="m_data.mondayEnabled"
                      readonly="readonly"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Martes"
                      :checked="m_data.tuesdayEnabled"
                      readonly="true"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Miércoles"
                      :checked="m_data.wednesdayEnabled"
                      readonly="true"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Jueves"
                      :checked="m_data.thursdayEnabled"
                      readonly="true"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Viernes"
                      :checked="m_data.fridayEnabled"
                      readonly="true"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>
                  <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                    <ejs-checkbox
                      label="Sábado"
                      :checked="m_data.saturdayEnabled"
                      readonly="true"
                      disabled="true"
                    ></ejs-checkbox>
                  </div>

                  <!--  -->
                </div>
              </div>
            </div>
            <span
              class="help e-text small"
              :class="{ 'e-warning': hasError('general') }"
              v-html="m_errors.general"
            ></span>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 p-3">
            <div class="card bg-light">
              <div class="card-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6 ">
                    <div class="form-group">
                      <label for="complexityId" style="padding: 0px 40px 0px 0"
                        >Día de la Semana</label
                      >
                      <ejs-dropdownlist
                        ref="weekDropDown"
                        id="weekDayId"
                        :showClearButton="true"
                        :dataSource="weekDays"
                        :fields="fields"
                        v-model="currentDay"
                        placeholder="Día de la Semana"
                      ></ejs-dropdownlist>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-lg-6 col-md-6 ">
                    <div class="centered">
                      <ejs-switch
                        cssClass="align-middle"
                        id="isDayEnabled"
                        @change="setWorkingDay"
                        :checked="isCurrentDayActive"
                        :disabled="isFormReadOnly"
                      >
                      </ejs-switch>
                      <label
                        for="isDayEnabled"
                        class="e-text align-middle switch-label"
                        >{{
                          isCurrentDayActive ? "Laborable" : "No Laborable"
                        }}</label
                      >
                    </div>
                  </div>
                  <div
                    class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                    style=" margin-top:20px;"
                  >
                    <ejs-grid
                      :dataSource="currentGridData"
                      :editSettings="editSettings"
                      :toolbar="toolbar"
                      :actionBegin="grid_ActionBegin"
                      locale="es-CO"
                      width="100%"
                    >
                      <e-columns>
                        <e-column
                          field="id"
                          :visible="false"
                          headerText="Id"
                          :isPrimaryKey="true"
                        ></e-column>
                        <e-column
                          field="weekDayId"
                          :visible="false"
                          headerText="Dia"
                        ></e-column>
                        <e-column
                          field="fromHour"
                          headerText="Hora Desde"
                          :width="120"
                          format="HH:mm"
                          editType="dropdownedit"
                          :edit="hourParams"
                          :validationRules="valHourRules"
                        ></e-column>
                        <e-column
                          field="toHour"
                          headerText="Hora Hasta"
                          :width="150"
                          format="HH:mm"
                          editType="dropdownedit"
                          :validationRules="valHourRules"
                          :edit="hourParams"
                        ></e-column>
                      </e-columns>
                    </ejs-grid>
                    <span
                      class="help e-text small"
                      :class="{ 'e-warning': hasError('calendarWeekHours') }"
                      v-html="m_errors.calendarWeekHours"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row pull-right">
          <div class="col-xs-12 col-sm-12 ">
            <div class="e-btn-group">
              <ejs-button
                @click.native="validateForm"
                :isPrimary="true"
                iconCss="e-icons icon-save inline-command"
                cssClass="e-flat e-noback"
                v-if="showSaveButton"
                :disabled="disableButtons"
                >Grabar</ejs-button
              >
              <ejs-button
                @click.native="validateDelete"
                :isDanger="true"
                iconCss="e-icons icon-trash inline-command"
                cssClass="e-flat e-danger e-noback"
                v-if="showDeleteButton"
                :disabled="disableButtons"
                >Desactivar</ejs-button
              >
              <ejs-button
                @click.native="close()"
                iconCss="e-icons icon-cancel inline-command"
                cssClass="e-flat e-noback"
                :disabled="disableButtons"
                >Cancelar</ejs-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </ejs-dialog>
</template>

<script>
import Vue from "vue";
/*import { object, string, number, yup, when } from "yup";*/

import { FormActionEnum } from "../../services/enums.js";
import PermissionMixin from "../../mixins/PermissionMixin";
import ToastMixin from "../../mixins/ToastMixin";
import CultureMixin from "../../mixins/CultureMixin";

/* Plugins de Syncfusion */
import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
import { SwitchPlugin } from "@syncfusion/ej2-vue-buttons";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DialogPlugin } from "@syncfusion/ej2-vue-popups";
import { CheckBoxPlugin } from "@syncfusion/ej2-vue-buttons";
import { GridPlugin, Page, Edit, Toolbar } from "@syncfusion/ej2-vue-grids";

import { DateTimePickerPlugin } from "@syncfusion/ej2-vue-calendars";
Vue.use(DateTimePickerPlugin);
import { Query } from "@syncfusion/ej2-data";

/* Utilidades Syncfusion */
import { DialogUtility } from "@syncfusion/ej2-popups";
import {
  createSpinner,
  showSpinner,
  hideSpinner
} from "@syncfusion/ej2-popups";

/* Validación con YUP*/

import * as Yup from "yup";
import { es } from "yup-locales";
import { setLocale } from "yup";
setLocale(es);

Vue.use(DialogPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(ButtonPlugin);
Vue.use(SwitchPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(GridPlugin);

export default Vue.extend({
  mixins: [PermissionMixin, ToastMixin, CultureMixin],
  computed: {
    showId() {
      return this.formAction !== FormActionEnum.ADD;
    },
    showSaveButton() {
      return (
        this.formAction === FormActionEnum.ADD ||
        this.formAction === FormActionEnum.EDIT
      );
    },
    showDeleteButton() {
      return this.formAction == FormActionEnum.DELETE;
    },
    customClass() {
      return {
        "dialog-karin": true,
        "dialog-edit":
          this.formAction == FormActionEnum.ADD ||
          this.formAction == FormActionEnum.EDIT,
        "dialog-view": this.formAction == FormActionEnum.VIEW,
        "dialog-delete": this.formAction == FormActionEnum.DELETE
      };
    },
    marginTopId() {
      var strMT = "auto;";

      switch (this.formAction) {
        case FormActionEnum.ADD:
          strMT = "margin-top: 20px;";
          break;
        default:
          strMT = "margin-top: 0;";
          break;
      }
      return strMT;
    },
    isFormReadOnly() {
      var ret = false;

      switch (this.formAction) {
        case FormActionEnum.ADD:
          break;
        case FormActionEnum.EDIT:
          break;
        case FormActionEnum.VIEW:
          ret = true;
          break;
        case FormActionEnum.DELETE:
          ret = true;
          break;
      }
      return ret;
    },
    header() {
      if (this.formAction === FormActionEnum.ADD) {
        return "Nuevo Calendario";
      }
      if (this.formAction === FormActionEnum.VIEW) {
        return "Consultar Calendario";
      }
      if (this.formAction === FormActionEnum.EDIT) {
        return "Modificar Calendario";
      }
      if (this.formAction === FormActionEnum.DELETE) {
        return "Deshabilitar Calendario";
      }
      return "";
    },
    canDelete() {
      if (!this.hasPermission("CanDelete")) {
        return false;
      }
      return true;
    },
    currentGridData() {
      var hasData = !!this.m_data.calendarWeekHours;

      if (!hasData) {
        return [];
      }
      var currentRows = this.m_data.calendarWeekHours.filter(
        x =>
          x.weekDayId == this.currentDay &&
          (x.removed == false || x.removed == undefined)
      );

      hasData = !!currentRows;
      if (hasData) {
        var newArray = JSON.parse(JSON.stringify(currentRows));
        newArray.sort((a, b) => {
          if (a.fromHour > b.fromHour) {
            return 1;
          }
          if (a.fromHour < b.fromHour) {
            return -1;
          }
          return 0;
        });
        return newArray;
      } else {
        return [];
      }
    },
    isCurrentDayActive() {
      var ret = false;
      switch (this.currentDay) {
        case 0:
          ret = this.m_data.sundayEnabled ?? false;
          break;
        case 1:
          ret = this.m_data.mondayEnabled ?? false;
          break;
        case 2:
          ret = this.m_data.tuesdayEnabled ?? false;
          break;
        case 3:
          ret = this.m_data.wednesdayEnabled ?? false;
          break;
        case 4:
          ret = this.m_data.thursdayEnabled ?? false;
          break;
        case 5:
          ret = this.m_data.fridayEnabled ?? false;
          break;
        case 6:
          ret = this.m_data.saturdayEnabled ?? false;
          break;
        default:
          ret = false;
          break;
      }
      return ret;
    },
    disableButtons() {
      return this.isSaving;
    }
  },
  data() {
    return {
      /* Datos del Componente*/
      isValid: false,
      isSaving: false,
      isMounted: false,
      calendarSchema: {},
      weekHoursSchema: {},
      m_errors: {},
      m_data: {},
      hourFormat: /^([0-1]?\d|2[0-3])(?::([0-5]?\d))(?::([0-5]?\d))?$/,
      fields: { text: "name", value: "id" },
      toolbar: ["Add", "Edit", "Delete", "Update", "Cancel"],
      currentDay: 0,
      hourList: [],
      editSettings: {
        allowEditing: true,
        allowAdding: true,
        allowDeleting: true
      },
      hourParams: {
        params: {
          allowFiltering: true,
          dataSource: this.getHourList(),
          fields: { text: "value", value: "value" },
          query: new Query(),
          actionComplete: () => false
        }
      },
      weekDays: [
        { id: 0, name: "Domingo" },
        { id: 1, name: "Lunes" },
        { id: 2, name: "Martes" },
        { id: 3, name: "Miércoles" },
        { id: 4, name: "Jueves" },
        { id: 5, name: "Viernes" },
        { id: 6, name: "Sábado" }
      ],
      valHourRules: {
        required: [true, "Campo Requerido"],
        minLength: [
          args => {
            return args["value"].length >= 5;
          },
          "Formato Requerido HH:mm"
        ]
      },
      /* Datos del Dialogo de Syncfusion*/
      isModal: true,
      /*isOpen: false,*/
      target: document.getElementById("dialog"),
      width: this.isMobile ? "500px" : "70%"
    };
  },
  provide: {
    grid: [Page, Edit, Toolbar]
  },
  created() {
    /* Obtener los datos de las zonas desde el  */
    /* this.formAction = FormActionEnum.LIST;*/
  },
  mounted() {
    try {
      //crear el spinner de loading

      createSpinner({
        /* target: document.getElementById("calendar-form")*/
        target: this.$refs.formDialog.$el
      });

      this.buildYupSchema();
      this.isMounted = true;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    getHourList() {
      var items = [];
      for (var i = 0; i <= 23; i++) {
        var hour = i.toString().padStart(2, 0);
        items.push({ value: hour + ":00" });
        items.push({ value: hour + ":15" });
        items.push({ value: hour + ":30" });
        items.push({ value: hour + ":45" });
        if (i == 23) {
          items.push({ value: hour + ":59" });
        }
      }
      return items;
    },
    validateHours(from, to, id) {
      var hFrom = from.split(":");
      var hTo = to.split(":");
      var intHourFrom = parseInt(hFrom[0]);
      var intHourTo = parseInt(hTo[0]);
      var intMinuteFrom = parseInt(hFrom[1]);
      var intMinuteTo = parseInt(hTo[1]);
      var valid = true;

      if (
        isNaN(intHourFrom) ||
        isNaN(intHourTo) ||
        isNaN(intMinuteFrom) ||
        isNaN(intMinuteTo)
      )
        return false;

      if (intHourFrom == intHourTo && intMinuteFrom >= intMinuteTo) {
        valid = false;
      } else if (intHourFrom > intHourTo) {
        valid = false;
      }

      if (valid){
        let array = this.m_data.calendarWeekHours.filter(x => (x.isNew == undefined || x.isNew == null || x.isNew == false) && x.id != id);
        array.forEach(item =>{
          var itemFrom = item.fromHour.split(":");
          var itemTo = item.toHour.split(":");
          var itemHourFrom = parseInt(itemFrom[0]);
          var itemHourTo = parseInt(itemTo[0]);
          var itemMinuteFrom = parseInt(itemFrom[1]);
          var itemMinuteTo = parseInt(itemTo[1]);

          if ((intHourFrom < itemHourFrom || (intHourFrom == itemHourFrom &&  intMinuteFrom <= itemMinuteFrom)) && 
              (intHourTo > itemHourFrom || (intHourTo == itemHourFrom && intMinuteTo >= itemMinuteFrom))){
                console.log("entro 1");
            valid = false;
          }

          if ((intHourFrom < itemHourTo || (intHourFrom == itemHourTo && intMinuteFrom <= itemMinuteTo)) && 
              (intHourTo > itemHourTo || (intHourTo == itemHourTo && intMinuteTo >= itemMinuteTo))){
              console.log("entro 2");
            valid = false;
          }

          if ((intHourFrom < itemHourFrom || (intHourFrom == itemHourFrom && intMinuteFrom < itemMinuteFrom)) && 
              (intHourTo > itemHourTo || (intHourTo == itemHourTo && intMinuteTo > itemMinuteTo))){
              console.log("entro 3");
            valid = false;
          }
          
          if ((itemHourFrom < intHourFrom || (itemHourFrom == intHourFrom && itemMinuteFrom < intMinuteFrom)) && 
              (itemHourTo > intHourTo || (itemHourTo == intHourTo && itemMinuteTo > intMinuteTo))){
              console.log("entro 4");
            valid = false;
          }
        });
      }

      return valid;
    },
    onDialogOpen() {
      this.m_data = Object.assign({}, this.formData);
    },
    onDialogClose() {
      this.clearErrors();
      this.currentDay = null;
      // if (args) args.cancel = true;
      this.$emit("formClosed");
    },
    close() {
      this.$emit("formClosed");
      /* forzar el cierre del componente */
      /* this.$refs.formDialog.close(); */
    },
    getAlertDialog(title, content) {
      let dialog = DialogUtility.alert({
        title: title,
        zindex: 1010,
        content: content,
        /* okButton: { text: "OK", click: okClick.bind(this) }, */
        /* cancelButton: {  text: 'Cancel', click: cancelClick.bind(this)},*/
        showCloseIcon: true,
        closeOnEscape: true,
        animationSettings: { effect: "Zoom" }
      });
      return dialog;
    },
    showSpinner() {
      showSpinner(this.$refs.formDialog.$el);
    },
    hideSpinner() {
      hideSpinner(this.$refs.formDialog.$el);
    },
    clearErrors() {
      this.m_errors = {};
    },
    grid_ActionBegin(args) {
      if (
        args.requestType == "save" &&
        (args.action == "add" || args.action == "edit")
      ) {
        var isValid = this.validateHours(args.data.fromHour, args.data.toHour, args.data.id);
        if (!isValid) {
          this.showToast(
            "Error",
            "Los datos ingresados no son validos, por favor verifica los valores de las horas",
            2000
          );
          args.cancel = true;
        }

        if (!args.cancel) {
          this.saveTempDate(args.data);
        }
      } else if (args.requestType == "delete") {
        //En el delete viene en un arreglo.
        this.deleteTempDate(args.data[0]);
      }
    },

    findweekHourArrayIndex(data) {
      var indice = -1;

      var len = this.m_data.calendarWeekHours.length;
      for (var i = 0; i < len; i++) {
        var el = this.m_data.calendarWeekHours[i];
        //var igualito = el.id == data.id && el.id != undefined;
        var igualito = this.isEqual(el, data);
        if (igualito) {
          indice = i;
          break;
        }
      }
      // this.m_data.calendarWeekHours.forEach((el, idx) => {
      //   var igualito = this.isEqual(el, data);
      //   if (igualito) {
      //     indice = idx;
      //   }
      // });
      return indice;
    },
    findweekHourArrayIndexById(data) {
      var indice = -1;
      var len = this.m_data.calendarWeekHours.length;

      for (var i = 0; i <= len; i++) {
        var el = this.m_data.calendarWeekHours[i];

        var igualito = el.id == data.id && el.id != undefined;

        if (igualito) {
          indice = i;
          break;
        }
      }

      // this.m_data.calendarWeekHours.forEach((el, idx) => {
      //   var igualito = el.id == data.id && el.id != undefined;
      //   if (igualito) {
      //     indice = idx;
      //   }
      // });

      return indice;
    },
    isEqual(s, d) {
      // console.log("source", s);
      // console.log("Destination", d);
      var ret = false;

      var sfh = s.fromHour.substring(0, 5);
      var dfh = d.fromHour.substring(0, 5);
      var sth = s.toHour.substring(0, 5);
      var dth = d.toHour.substring(0, 5);

      var str1 = `${s.id}|${s.calendarId}|${s.weekDayId}|${s.weekDayName}|${sfh}|${sth}`;
      var str2 = `${d.id}|${d.calendarId}|${d.weekDayId}|${d.weekDayName}|${dfh}|${dth}`;

      ret = str1 == str2;
      /*
      if (s.id == undefined || d.id == undefined) {
        ret =
          s.calendarId == d.calendarId &&
          s.weekDayId == d.weekDayId &&
          s.weekDayName == d.weekDayName &&
          s.fromHour.substring(0, 5) == d.fromHour.substring(0, 5) &&
          s.toHour.substring(0, 5) == d.toHour.substring(0, 5);
      } else {
        ret =
          s.id == d.id &&
          s.calendarId == d.calendarId &&
          s.weekDayId == d.weekDayId &&
          s.weekDayName == d.weekDayName &&
          s.fromHour.substring(0, 5) == d.fromHour.substring(0, 5) &&
          s.toHour.substring(0, 5) == d.toHour.substring(0, 5);
      }
*/
      return ret;
    },
    mapDataToNewData(data) {
      var newData = JSON.parse(JSON.stringify(data));

      if (newData.id == undefined) {
        newData.isNew = true;
        newData.calendarId = this.m_data.id;
      } else {
        newData.isNew = false;
      }

      if (newData.weekDayId == undefined) {
        newData.weekDayId = this.currentDay;
        newData.weekDayName = this.getDayName(this.currentDay);
      }
      return newData;
    },
    deleteTempDate(data) {
      var newData = this.mapDataToNewData(data);
      // var index = this.findweekHourArrayIndex(newData);
      var index = -1;
      if (newData.isNew) {
        index = this.findweekHourArrayIndex(newData);
      } else {
        index = this.findweekHourArrayIndexById(newData);
      }

      if (newData.isNew) {
        if (index >= 0) this.$delete(this.m_data.calendarWeekHours, index);
      } else {
        if (index >= 0) {
          newData.removed = true;
          this.$set(this.m_data.calendarWeekHours, index, newData);
        }
      }
    },
    saveTempDate(data) {
      var newData = this.mapDataToNewData(data);

      var index = -1;
      if (newData.isNew) {
        index = this.findweekHourArrayIndex(newData);
      } else {
        index = this.findweekHourArrayIndexById(newData);
      }

      if (index >= 0) {
        this.$set(this.m_data.calendarWeekHours, index, newData);
      } else {
        this.m_data.calendarWeekHours.push(newData);
      }
    },
    getDayName(day) {
      var semana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado"
      ];
      return semana[day];
    },
    setWorkingDay(args) {
      switch (this.currentDay) {
        case 0:
          this.m_data.sundayEnabled = args.checked ?? false;
          break;
        case 1:
          this.m_data.mondayEnabled = args.checked ?? false;
          break;
        case 2:
          this.m_data.tuesdayEnabled = args.checked ?? false;
          break;
        case 3:
          this.m_data.wednesdayEnabled = args.checked ?? false;
          break;
        case 4:
          this.m_data.thursdayEnabled = args.checked ?? false;
          break;
        case 5:
          this.m_data.fridayEnabled = args.checked ?? false;
          break;
        case 6:
          this.m_data.saturdayEnabled = args.checked ?? false;
          break;
      }
    },
    getDayEnabled(weekDay) {
      switch (weekDay) {
        case 0:
          return this.m_data.sundayEnabled;
        case 1:
          return this.m_data.mondayEnabled;
        case 2:
          return this.m_data.tuesdayEnabled;
        case 3:
          return this.m_data.wednesdayEnabled;
        case 4:
          return this.m_data.thursdayEnabled;
        case 5:
          return this.m_data.fridayEnabled;
        case 6:
          return this.m_data.saturdayEnabled;
      }
    },
    async saveData() {
      try {
        this.isSaving = true;
        this.showSpinner();
        switch (this.formAction) {
          case FormActionEnum.VIEW:
            this.showToast(
              "No habilitado",
              "Modo consulta, nada para grabar!",
              2000
            );
            break;
          case FormActionEnum.ADD:
            this.m_data.isActive = true;
            await this.$store.dispatch("calendars/createCalendar", this.m_data);

            this.showToast("Confirmación", "Registro Creado!", 2000);
            break;
          case FormActionEnum.EDIT:
            await this.$store.dispatch("calendars/updateCalendar", {
              id: this.m_data.id,
              calendar: JSON.parse(JSON.stringify(this.m_data))
            });
            this.showToast("Confirmación", "Registro Actualizado", 2000);
            break;
        }
        await this.$store.dispatch("calendars/getCalendars");
        /* esperar medio segundo antes de cerrar */
        setTimeout(() => {
          this.isSaving = false;
          this.hideSpinner();
          this.close();
        }, 500);
      } catch (error) {
        this.isSaving = false;
        this.hideSpinner();
        this.showToast(
          "Error!",
          "Ocurrió un error al ejecutar la operación",
          2000
        );
      }
    },
    isDayValidWithHours(weekDay) {
      var hasData = !!this.m_data.calendarWeekHours;
      var count = this.m_data.calendarWeekHours.length;
      var validationError = null;
      if (!hasData || count == 0) {
        return "No existe ningún horario laboral definido";
      }

      var currentRows = this.m_data.calendarWeekHours.filter(
        x =>
          x.weekDayId == weekDay &&
          (x.removed == false || x.removed == undefined)
      );

      hasData = !!currentRows;
      if (hasData && currentRows.length > 0) {
        validationError = null;
      } else {
        if (this.getDayEnabled(weekDay)) {
          validationError =
            "No existe horario laboral definido para el dia :" +
            this.getDayName(weekDay);
        } else {
          validationError = null;
        }
      }
      return validationError;
    },

    buildYupSchema() {
      /*Hack para esLint*/

      this.calendarSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        description: Yup.string()
          .required()
          .max(50)
          .label("Calendario"),
        calendarWeekHours: Yup.array().min(
          1,
          "Debe ingresar al menos 1 horario laboral para el calendario"
        )
        //.label("Horario Laboral")
      });

      var hourRegEx = this.hourFormat;
      this.weekHoursSchema = Yup.object().shape({
        isNew: Yup.boolean(),
        calendarId: Yup.number().when("isNew", {
          is: true,
          then: Yup.number().min(1),
          otherwise: Yup.number()
        }),
        weekDayId: Yup.number()
          .required()
          .min(0)
          .max(6)
          .label("Día de la Semana"),
        fromHour: Yup.string()
          .matches(hourRegEx, "El formato de la hora no es válido")
          .label("Hora Desde"),
        toHour: Yup.string()
          .matches(hourRegEx, "El formato de la hora no es válido")
          .label("Hora Hasta")
      });
    },
    hasError(field, index) {
      if (index != undefined) field = field + "_" + index;
      return !!this.m_errors[field];
    },
    async validateField(field, index) {
      var errorName = field;
      if (index != undefined) errorName = errorName + "_" + index;
      Vue.set(this.m_errors, errorName, "");

      if (this.isFormReadOnly) return;

      this.calendarSchema.validateAt(field, this.m_data).catch(err => {
        var customPath = err.path;
        if (index != undefined) customPath = customPath + "_" + index;
        Vue.set(this.m_errors, customPath, err.message);
      });
    },
    async validateForm() {
      this.isValid = false;
      this.m_errors["general"] == "";
      try {
        await this.calendarSchema.validate(this.m_data, {
          abortEarly: false
        });

        this.m_errors = {};
        /*Grabar los datos*/
        var valid = await this.validateData();
        if (valid) {
          await this.saveData();
        }
      } catch (error) {
        error.inner.forEach(error => {
          Vue.set(this.m_errors, error.path, error.message);
          //this.m_errors[error.path] = error.message;
        });
      }
    },
    async validateData() {
      await this.$store.dispatch("calendars/getCalendars");
      var listCalendar = this.$store.getters["calendars/allCalendars"];
      var listado = listCalendar.filter(u => u.id !== this.m_data.id);

      if (
        listado.find(
          element =>
            element.description.toUpperCase().trim() ===
            this.m_data.description.toUpperCase().trim()
        )
      ) {
        this.showToast(
          "Invalido!",
          "Ya existe un calendario con la misma descripción",
          2000
        );
        return false;
      }

      var errors = [];
      for (var i = 0; i <= 6; i++) {
        var msg = this.isDayValidWithHours(i);
        if (msg != null) errors.push(msg);
      }

      if (errors.length > 0) {
        this.showToast(
          "Invalido!",
          "Existe una inconsistencia en los horarios, por favor verifique",
          2000
        );
        Vue.set(this.m_errors, "general", errors.join("<br/>"));
        return false;
      }

      return true;
    }
  },

  props: {
    /** Whether the dialog is currently showing */
    showing: {
      type: Boolean,
      required: true,
      default: false
    },
    formAction: {
      type: Number,
      required: true,
      default: 0
    },
    isMobile: {
      type: Boolean,
      required: true,
      default: false
    },
    formData: {
      type: Object,
      required: false,
      default() {
        return { id: 0, name: "", isActive: false };
      }
    }
  }
});
</script>

<style scoped>
@import url(../../../node_modules/@syncfusion/ej2-base/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-buttons/styles/fabric.css);
@import url(../../../node_modules/@syncfusion/ej2-vue-calendars/styles/fabric.css);
@import url(../form-icons.css);

.dialog-karin.e-dialog .e-dlg-header {
  color: #0078d6;
  font-size: 20px;
  font-weight: normal;
}

.content-wrapper div.row {
  padding: 5px 0px;
}

.switch-label {
  padding: 0px 0px 0px 20px;
  margin: auto;
  cursor: pointer;
}

.e-save.e-icons:before,
.e-save.e-icons:before {
  content: "\e609";
}

@media only screen and (max-width: 480px) {
  .content-wrapper {
    width: 92%;
  }
  .e-input-section .col-xs-6,
  .e-input-section .col-xs-4,
  .e-input-section .col-xs-12 {
    padding: 10px 5px;
    width: 100%;
  }
  .content-wrapper div.row {
    padding: 0px;
  }
}

div.centered {
  margin: 0;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
